import { canActivateShipments, canEnableInvoicing } from '@/lib/customer'
import type { Customer } from '@/api/types'

export type BulkActivationKind = 'shipments' | 'invoicing'

interface BulkActivationDefinition {
  subject: string
  consequence: string
  isEligible: (customer: Customer) => boolean
}

export const BULK_ACTIVATION_KINDS: BulkActivationKind[] = ['shipments', 'invoicing']

const DEFINITIONS: Record<BulkActivationKind, BulkActivationDefinition> = {
  shipments: {
    subject: 'leveranser',
    consequence: 'Riktiga PostNord-frakter bokas automatiskt.',
    isEligible: canActivateShipments
  },
  invoicing: {
    subject: 'fakturering',
    consequence: 'Riktiga fakturor skapas hos Capway vid nästa körning – även för leveranser som redan har skickats.',
    isEligible: canEnableInvoicing
  }
}

export function isEligibleForBulkActivation(kind: BulkActivationKind, customer: Customer): boolean {
  return DEFINITIONS[kind].isEligible(customer)
}

// En kund går att bocka i så länge minst en av åtgärderna i menyn fortfarande gäller den.
export function canBulkActivate(customer: Customer): boolean {
  return BULK_ACTIVATION_KINDS.some((kind) => isEligibleForBulkActivation(kind, customer))
}

export function getBulkActivationLabel(kind: BulkActivationKind, count: number): string {
  return `Aktivera ${DEFINITIONS[kind].subject} (${count})`
}

export function getBulkActivationConfirmMessage(kind: BulkActivationKind, count: number): string {
  const { subject, consequence } = DEFINITIONS[kind]
  const target = count === 1 ? 'kunden' : `${count} kunder`

  return `Vill du aktivera ${subject} för ${target}? ${consequence}`
}

export function getBulkActivationErrorMessage(kind: BulkActivationKind, failedCount: number, totalCount: number): string {
  return `Kunde inte aktivera ${DEFINITIONS[kind].subject} för ${failedCount} av ${totalCount} kunder.`
}
